import { render, staticRenderFns } from "./customized-recipes.vue?vue&type=template&id=42f5b0ca&scoped=true&"
import script from "./customized-recipes.vue?vue&type=script&lang=js&"
export * from "./customized-recipes.vue?vue&type=script&lang=js&"
import style0 from "./customized-recipes.vue?vue&type=style&index=0&id=42f5b0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f5b0ca",
  null
  
)

export default component.exports